import type { IconProps } from '../types/IconProps.ts';
export const UserMinus: IconProps = {
    name: 'UserMinus',
    children: [
        `<path d="M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />`,
        `<path d="M15.15 13.64A8 8 0 0 0 4 21M16 19h6" />`,
    ]
};